import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Providers from "./Providers";
import "./styles/global.css";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

window.onerror = function (message, source, lineno, colno, error) {
  document.body.innerHTML = `
    <div style="padding:20px;font-family:monospace;white-space:pre-wrap;color:red;">
      ${message}

      ${source}
      Line: ${lineno}
      Column: ${colno}

      ${error?.stack || ""}
    </div>
  `;
};

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
